import React, { Component } from "react";
import config from "react-global-configuration";
import jwt_decode from "jwt-decode";
import { Link, Redirect } from "react-router-dom";
import $ from "jquery";
import "../css/ipos-navbar.css";
import "../css/TotalEMI.css";
import DownArrow from "../../assets/img/welcomepage/down-arrow.png";
import BellIcon from "../../assets/img/welcomepage/TopbarIcons/bell.png";
import HomeIcon from "../../assets/img/welcomepage/TopbarIcons/home-icon.png";
import { Modal, ModalBody } from "react-responsive-modal";
import { Button } from 'react-bootstrap';
// import  {Modal,Button} from 'react-bootstrap';



const closeIcon = (
  <svg fill="currentColor" viewBox="0 0 20 20" width={28} height={28}>
    <path
      fillRule="evenodd"
      d=""
      clipRule="evenodd"
    ></path>
  </svg>
)
// const useStyles = makeStyles({
//   avatar: {
//     backgroundColor: blue[100],
//     color: blue[600],
//   },
// });
// const classes = useStyles();
class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homeicon: true,
      TermModal: false,
      selectedradio:'All Terminals',
    };
  }
  componentDidMount() {
    this.checkicon();
   
  }
 
  checkicon = () => {
    var icon = localStorage.getItem("MenuList");
    console.log(icon);
    if (icon.includes("TRUE")) {
      this.setState({ homeicon: true });
    }
  };

  activeclass = () => {
    //    alert('active');
    $("#iposnav").removeClass("active");
    $("#iposnav").addClass("active");
  };
  toggle = () => {
    // e.preventDefault();
    $("#iposnav").toggleClass("collapse");
  };
  callchild() {
    this.setState({ TermModal: true })
    // this.props.callbackFromParent("All terminal");
  }
  homepage = () => {
    return <Redirect to="/admin/welcomepage" />;
  };


  onCloseModal = () => {
    this.setState({
      TermModal: false,

    })
  }

  applyterminsl=()=>{
    this.setState({
      TermModal: false,
    })
    this.props.callbackFromParent(this.state.selectedradio);
  }

  handleListItemClick = (value) => {
    //onClose(value);
  };
  
  checkterminal = (e) => {
    let currter=e.target.title;
    this.setState({selectedradio:currter})
  };
  
  render() {
    return (
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
        <Modal
          open={this.state.TermModal}
          onClose={this.onCloseModal}
          classNames={{
            overlay: "customOverlay",
            modal: "customModal",
          }}
          closeIcon={closeIcon}
          center
        >
          <h4 style={{ color: '#F47626', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid', paddingBottom: '10px' }}>Select Terminal</h4>
          <div style={{ padding: '0px 60px' }}>
          <div onClick={this.checkterminal}>
            <input type="radio"  checked={this.state.selectedradio.includes("All")?true:false} title="All terminals" onClick={this.checkterminal}/>
            <h5 style={{ display: 'inline-block', paddingLeft: '10px' }} title="All terminals">All terminals</h5>
            <br />
          </div>
            { this.props.allterminals.map((terval, terkey) => {
              return (
                <div onClick={this.checkterminal}>
                  <input type="radio" checked={this.state.selectedradio===terval}  title={terval} onClick={this.checkterminal} />
                  <h5 style={{ display: 'inline-block', paddingLeft: '10px' }} title={terval}> {terval} (Terminal {terkey + 1})</h5>
                  <br />
                </div>
              )
            })
            }

          </div>
          <div className="text-center p-5">
            <Button
              style={{
                background: "#ef7731",
                color: "#fff",
                borderRadius: "10px",
                width: "100px",
                margin: "5px",
              }}
              onClick={this.onCloseModal}
              align="center"
            >
              Cancel
                    </Button>
            <Button
              style={{
                background: "#ef7731",
                color: "#fff",
                borderRadius: "10px",
                width: "100px",
                margin: "5px",
              }}
              onClick={()=>{this.applyterminsl()}}
              align="center"
            >
              Apply
                    </Button>
          </div>


        </Modal> 
              
      {/* <Modal show={this.state.TermModal} size="sm" centered={true} >
         <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-sm">
           Select Terminals
          </Modal.Title >
        </Modal.Header>
        <Modal.Body>
        <Iframe url="https://totalemi.innoviti.com:30011/eslip/C000260120200319194816651223224072215"
                    height="450px"
                    width="auto"
                    display="initial"
                    position="relative"
                    />
       
        </Modal.Body>
        <Modal.Footer>
           <Button variant="outline-primary">Cancel</Button>{' '}
        <Button variant="outline-primary">Apply</Button>{' '}
       
        </Modal.Footer>
      </Modal>
         */}
        <div className="container-fluid">
          <div className="row">

            <div className="rectangle">
              <p className="all-terminals">
                {this.state.homeicon && (
                  <Link to="/admin/welcomepage">
                    <img
                      src={HomeIcon}
                      style={{
                        float: "left",
                        height: "30px",
                        paddingLeft: "10px",
                      }}
                    />
                  </Link>
                )}
                <span
                  style={{
                    color: "darkblue",
                    fontSize: "130%",
                    fontWeight: "600",
                  }}
                >
                  Total EMI
                </span>{" "}
                <img
                  src={BellIcon}
                  style={{
                    float: "right",
                    paddingRight: "5px",
                    height: "30px",
                  }}
                />
              </p>
              <p className="text-center" style={{ paddingTop: "5px" }} onClick={() => { this.callchild() }}>
                <span style={{ paddingLeft: "5px" }}>{this.props.selectedterminals} </span>{" "}
                <img
                  src={DownArrow}
                  style={{ marginLeft: "3px", marginTop: "-3px" }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Navbar;
